export default "<style>\r\n  *[data-editable] edit-properteis\r\n  {\r\n    display: none;\r\n  }\r\n\r\n</style>";